/** lib **/
import s from '../../styles/molecules/friend-item.module.scss';
/** style **/
import classNames from 'classnames';

type Props = {
  className?: string;
  characters: string[];
  name: string;
  image: string;
  subName?: string;
  imageWidth: number;
  hurigana?: string;
  handleClick: () => void;
};

export const FriendItem: React.FC<Props> = ({ className, name, image, imageWidth, subName, hurigana, handleClick }) => {

  return (
    <>
      <div className={classNames(className, s.friendItemWrapper)} onClick={handleClick}>
        <div className={s.imageWrapper}>
          <img src={require(`assets/images/${image}`)} alt={name} width={imageWidth} />
        </div>
        <div className={s.nameWrapper}>
          <p className={s.name}>
            {hurigana && <span className={s.hurigana}>{hurigana}</span>}
            {name}
          </p>
        </div>
      </div>
    </>
  );
};
